import React, { useEffect, useState } from "react";
import { Space, Button, Drawer, Modal, Checkbox } from "antd";
import { DragOutlined, EditOutlined, DeleteOutlined, CopyOutlined, MoreOutlined, DoubleLeftOutlined, SendOutlined } from '@ant-design/icons';
import moment from "moment";
import uuid from 'react-uuid'
import Cookies from "js-cookie";
import MoveComponent from "../../UI/MoveComponent";
import { getComponentLabel } from "../../../utils/Utils";

export default function Wrapper(props) {

    const { containerRef = { current: false }, getGlobals = () => { }, getContent = () => { }, page = 0, view = "desktop", setView = () => { }, menus = [], selected = "", setSelected = () => { }, name = "", open = "", meta = {}, editing = false, setEditing = () => { } } = props;
    const { deleteItem = () => { }, saveItem = () => { }, content = {}, id = 0 } = meta;
    const [edit, setEdit] = useState(false);
    const [visible, setVisible] = useState(false);
    const [more, setMore] = useState(false);

    useEffect(() => {
        if (selected === id || selected === content.component) {
            setEdit(true);
            setEditing(true);
        }
    }, [selected])

    const duplicate = (_from_id) => {
        let dupe = { ...content };
        dupe.id = uuid();
        dupe.visibility = "test";
        // Prefix clone...
        if (dupe.name.substr(0, 8) !== "(Clone) ") {
            dupe.name = "(Clone) " + dupe.name;

        }
        saveItem(dupe.id, dupe, _from_id);
    }

    const openEdit = () => {
        setEdit(true);
        setEditing(true);
    }

    const closeEdit = (warn = false) => {
        if (warn && !Cookies.get("hide_content_warning")) {
            Modal.confirm({
                title: "Warning",
                content: <>Closing without saving will revert changes.<br />
                    <Checkbox onChange={(e) => { Cookies.set("hide_content_warning", e.target.checked) }} ><div className="shim" /><div className="shim" /><span>Don't show this message again</span></Checkbox>
                </>,
                onOk: () => {
                    setSelected("");
                    setEdit(false);
                    setEditing(false);
                }
            })
        }
        else {
            setSelected("");
            setEdit(false);
            setEditing(false);
        }
    }

    const saveAndClose = () => {
        setVisible(false);
    }

    let hl = {
        "position": "relative",
        "zIndex": "600",
        "border": "2px dashed deeppink"
    }

    const getStatus = () => {
        let ret = "";
        switch (content.visibility) {
            case "hidden":
                ret = "hidden"
                break;
            case "visible":
                const now = Math.floor(Date.now() / 1000);
                const before = content.start_date && content.start_date > now; 
                const after = content.end_date && content.end_date < now; 
                if (before || after) {
                    ret = "hidden";
                } else if (content.start_date || content.end_date) {
                    ret = "scheduled";
                } else {
                    ret = "visible";
                }
                break;
            default:
                ret = "test"
        }
        return ret;
    }

    const draw = (_component) => {
        if (!open || editing) {
            return <div style={(edit) ? hl : {}} >{_component}</div>
        }
        let end_date = (content.end_date) ? <small><em>Expires {moment(content.end_date * 1000).format("MMM Do, YYYY @ hh:mma")} </em></small> : ""
        return (
            <div className={"wrapper wrapper-" + getStatus()}>
                <div className={"wrapper-label wrapper-" + getStatus()}>{(!content.name) ? content.data.name : content.name} <small style={{ "opacity": "0.7" }}>(<em>{getComponentLabel(content.component)}</em>)</small></div>
                <div className="wrapper-overlay">
                    <div>{(!content.name) ? content.data.name : content.name} {end_date}
                    </div>
                    <div className="shim" />
                    <Space>
                        <Button className="cnt-btn dragHandle" size="small"><DragOutlined style={{ "fontSize": "13px" }} /></Button>
                        <Button onClick={() => { if (Number.isInteger(id)) { openEdit(!editing) } }} className="cnt-btn" size="small"><EditOutlined style={{ "fontSize": "13px" }} /> Edit</Button>
                        {(more && <Button onClick={() => deleteItem(id)} className="cnt-btn" size="small"><DeleteOutlined style={{ "fontSize": "12px" }} /> Delete</Button>)}
                        {(more && <Button onClick={() => duplicate(id)} className="cnt-btn" size="small"><CopyOutlined style={{ "fontSize": "12px" }} /> Duplicate</Button>)}
                        {(more && <MoveComponent meta={meta} getGlobals={getGlobals} getContent={getContent} component_id={id} page_id={page} menus={menus}><Button className="cnt-btn" size="small"><SendOutlined style={{ "fontSize": "12px" }} /> Move</Button></MoveComponent>)}
                        {(content.can_delete && <>
                            <Button onClick={() => setMore(!more)} className="cnt-btn" size="small">
                                {(!more && <MoreOutlined style={{ "fontSize": "12px" }} />)}
                                {(more && <DoubleLeftOutlined style={{ "fontSize": "12px" }} />)}
                            </Button>
                        </>)}
                    </Space>
                </div>
                <Drawer closeIcon={null} bodyStyle={{ "padding": "10px", transition: "none" }} width={300} onClose={() => saveAndClose(true)} open={visible}>
                    edit form
                </Drawer>
                <div>
                    {_component}
                </div>
            </div>
        )
    }

    return draw(React.cloneElement(props.children, { page : page, id: id, items : props?.items, view: view, setView: setView, menus: menus, saveItem: saveItem, deleteItem: deleteItem, edit: edit, close: closeEdit, content: content, containerRef: containerRef }));
}